import {PPResponse} from '@gongxigames/framework/integrations/pariplay/response/PPResponse';
import {PPConfiguration} from '@gongxigames/framework/integrations/pariplay/PPConfiguration';

export class PPLoadGameResponse extends PPResponse {
    public getBalance(): number {
        return PPConfiguration.convertDoubleToInt(this.source.Status.Balance);
    }

    public getPlayerTokenID(): string {
        return this.source.PlayerTokenId;
    }

    public isUKRegulations(): boolean {
        return this.source.UkRegulations;
    }

    public getCashierUrl(): string {
        return this.source.CashierUrl;
    }

    public getHistoryUrl(): string {
        return this.source.HistoryUrl;
    }

    public getInGameHistoryUrl(): string {
        return this.source.InGameHistoryUrl;
    }

    public getDontLoadUrlFromParent(): boolean {
        return this.source.DontLoadUrlFromParent;
    }

    public shouldShowBalance(): boolean {
        return !this.source.DontShowBalance;
    }

    public shouldShowStake(): boolean {
        return !this.source.DontShowStake;
    }

    /**
     * parameter value may be 0, positive (0...1) or negative (positive value is volume level)
     */
    public getSoundVolume(): number {
        if (this.source.Sound === undefined) {
            return 0;
        }

        if (Number(this.source.Sound) >= 0) {
            return Number(this.source.Sound);
        }

        return 0;
    }

    public getCurrencyCode(): string {
        return this.source.CurrencyCode;
    }

    public getBet(): number {
        return PPConfiguration.convertDoubleToInt(this.source.DefaultStake);
    }

    public getBets(): number[] {
        const bets: number[] = [];

        for (let i = 0; i < this.source.Stakes.length; i++) {
            bets[i] = PPConfiguration.convertDoubleToInt(this.source.Stakes[i]);
        }

        return bets;
    }

    public getAutoPlayValues(): number[] {
        return this.source.AutoBetRounds;
    }

    public getBalanceURL(): string {
        return this.source.BalanceUrl;
    }

    public getEndFreeGameUrl(): string {
        return this.source.EndFreeGameUrl;
    }

    public getEndUrl(): string {
        return this.source.EndUrl;
    }

    public getHomeUrl(): string {
        return this.source.HomeUrl;
    }

    public getNotifyUrl(): string {
        return this.source.NotifyUrl;
    }

    public getPlaceBetUrl(): string {
        return this.source.PlaceBetUrl;
    }

    public getRPBody(): any {
        const res: any = {};

        res.data = JSON.parse(this.source.GameClientState);

        return res;
    }
}
